import styled from '@emotion/styled';

interface StyledTbmStatusProps {
  isCollapsed?: boolean;
  rightScrollX?: number;
  bodyScrollY?: number;
}

export const StyledTbmStatus = styled.div<StyledTbmStatusProps>`
  overflow-y: scroll;
  height: 100%;

  .status-wrapper {
    padding: 0;
    display: flex;
    justify-content: space-between;
    height: 100%;
    background-color: #fff;

    &-left {
      width: 60%;
      /* height: 100%; */
      background-color: #fff !important;
      padding-left: 24px;
      overflow: scroll;

      &-top {
        > div {
          margin: 0 !important;
        }
      }

      &-content {
        /* height: 84vh; */
        display: flex;
        flex-direction: column;

        &-top {
          display: flex;
          align-items: center;
          justify-content: space-around;
          gap: 20px;
          padding-bottom: 24px;

          &-left {
            width: 60%;
            gap: 12px;
          }

          &-right {
            width: 40%;
          }
        }

        &-middle {
          justify-content: space-between;
          display: flex;
          overflow-x: scroll;
          padding-right: 24px;

          &-box {
            display: flex;
            align-items: center;
            gap: ${({ isCollapsed }) => (isCollapsed ? '5px' : '12px')};

            &-label {
              color: #2f2f35;
              white-space: nowrap;
            }

            &-select {
              > div {
                margin: 0 !important;

                .MuiSelect-select {
                  width: 122px;
                }
              }

              &.flex {
                display: flex;
                align-items: center;
                gap: ${({ isCollapsed }) => (isCollapsed ? '5px' : '12px')};
              }
            }

            &:nth-of-type(2) {
              padding: ${({ isCollapsed }) => (isCollapsed ? '0 10px' : '0 5px')};
            }
          }
        }

        &-bottom {
          /* margin-top: 20px; */
          padding-right: 15px;
          max-height: 350px;
        }
      }
    }

    &-right {
      width: 40%;
      padding: 24px;
      background-color: #f4f5f6;

      > form {
        background-color: #fff;

        .dialogue-wrapper {
          margin-top: 0 !important;
          height: 90vh;
          overflow: scroll;
          min-width: ${({ rightScrollX }) =>
            rightScrollX ? `${rightScrollX}px` : '100%'} !important;
        }
      }
    }

    .tbm-table-status {
      height: 28px;

      display: flex;
      align-items: center;
      justify-content: center;

      &-ALL {
        border-radius: 4px;
        background-color: #58bdcb;
        margin: 0px 16px 0px 16px;
        font-family: Poppins;
        font-size: 14px;
        font-weight: 500;
        line-height: 21px;
        text-align: center;
        padding: 3px 12px;
        color: #fff;
      }

      &-SCHEDULED {
        border-radius: 4px;
        background-color: #ffbd59;
        margin: 0px 16px 0px 16px;
        font-family: Poppins;
        font-size: 14px;
        font-weight: 500;
        line-height: 21px;
        text-align: center;
        padding: 3px 12px;
        color: #fff;
      }

      &-WORKING {
        border-radius: 4px;
        background-color: #306cd2;
        margin: 0px 16px 0px 16px;
        font-family: Poppins;
        font-size: 14px;
        font-weight: 500;
        line-height: 21px;
        text-align: center;
        padding: 3px 12px;
        color: #fff;
      }

      &-COMPLETE {
        border-radius: 4px;
        background-color: #adadad;
        margin: 0px 16px 0px 16px;
        font-family: Poppins;
        font-size: 14px;
        font-weight: 500;
        line-height: 21px;
        text-align: center;
        padding: 3px 12px;
        color: #fff;
      }
    }

    .tbm-table-task-level {
      height: 28px;
      padding: 3px 12px;
      display: flex;
      align-items: center;
      justify-content: center;

      &-ALL {
        border: 1px solid #58bdcb;
        border-radius: 4px;
        color: #58bdcb;
        margin: 0px 16px 0px 16px;
        font-family: Poppins;
        font-size: 14px;
        font-weight: 500;
        line-height: 21px;
        text-align: center;
        padding: 3px 12px;
      }

      &-GENERAL {
        border: 1px solid #67b18f;
        border-radius: 4px;
        color: #67b18f;
        margin: 0px 16px 0px 16px;
        font-family: Poppins;
        font-size: 14px;
        font-weight: 500;
        line-height: 21px;
        text-align: center;
        padding: 3px 12px;
      }

      &-HIGH_RISK {
        border: 1px solid #de3e47;
        border-radius: 4px;
        color: #de3e47;
        margin: 0px 16px 0px 16px;
        font-family: Poppins;
        font-size: 14px;
        font-weight: 500;
        line-height: 21px;
        text-align: center;
        padding: 3px 12px;
      }
    }
  }

  .noContent {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .attend-table .MuiTableContainer-root {
    max-height: 80vh;
    min-height: 300px;
  }

  //.table-pagination {
  //  width: 100%;
  //  justify-content: center;
  //}
`;

export const StyledTbmStatusRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;

  .label {
    color: #2f2f35;
    white-space: nowrap;
  }
`;

export const StyledTbmStatusColumn = styled.div`
  display: flex;
  flex-direction: column;
`;
